module.exports = __webpack_public_path__ + "img/yesOrNoEle.ae9aaeb0.svg";